module.exports = __webpack_public_path__ + "img/p_selectedB@2x.415b74d4.png";